import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { MarkovState, MarkovGroupState } from "server/models"
import { StateType } from "client/utils"
import {
    StoreType,
    MarkovGroupProps,
    MarkovStateFilters,

    SortMarkovStates,
    AddMarkovGroupStates,

    setNotAssignedMarkovGroupStateIds,
    setNotAssignedMarkovGroupStateSort,
    setNotAssignedMarkovGroupStateFilters,
    setNotAssignedMarkovGroupStateSelected,
    setMarkovGroupStateReloadList,
    closeModal,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    PageForm,
    Button,
    TableSearchWrapper,
    Table,
    SortRows,
    SpinnerIcon,
} from "client/components"

import MarkovStateSearch from "client/pages/search/markovStateSearch"
import Columns from "./columns"

let isMounted: boolean

const NotAssignedGroupStates = ({
    groupId = null,
}: MarkovGroupProps) => {
    const model = useSelector((state: StoreType) => state.markovModel.modelView)
    const stateList = useSelector((state: StoreType) => state.markovState.stateList)
    const groupStateList = useSelector((state: StoreType) => state.markovGroupState.groupStateList)

    const stateIds = useSelector((state: StoreType) => state.markovGroupState.notAssignedStates.stateIds)
    const sortColumn = useSelector((state: StoreType) => state.markovGroupState.notAssignedStates.sortColumn)
    const sortOrder = useSelector((state: StoreType) => state.markovGroupState.notAssignedStates.sortOrder)
    const filters = useSelector((state: StoreType) => state.markovGroupState.notAssignedStates.filters)
    const selected = useSelector((state: StoreType) => state.markovGroupState.notAssignedStates.selected)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [saveState, setSaveState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        return () => {
            isMounted = false
        }
    }, [])

    useEffect(() => {
        const sortedStateIds = SortMarkovStates(Object.values(stateList), sortColumn, sortOrder, filters)
        const groupStateIds = groupStateList && groupStateList[groupId] ? groupStateList[groupId] : []

        const sortedNotAssigned = sortedStateIds.filter((stateId) => !groupStateIds.includes(stateId))
        dispatch(setNotAssignedMarkovGroupStateIds(sortedNotAssigned))
    }, [groupStateList, sortColumn, sortOrder, filters])

    const onSort: SortRows = (column: keyof MarkovState, order) => {
        dispatch(setNotAssignedMarkovGroupStateSort(column, order))
    }

    const onFilter = (newFilters: MarkovStateFilters) => {
        dispatch(setNotAssignedMarkovGroupStateFilters(newFilters))
        dispatch(setNotAssignedMarkovGroupStateSelected(null))
    }

    const addGroupStates = () => {
        setSaveState(PENDING)

        const data: MarkovGroupState[] = []
        selected.forEach((stateId) => {
            const newGroupState: MarkovGroupState = {
                modelId: model.id,
                groupId,
                stateId,
            }
            data.push(newGroupState)
        })
        AddMarkovGroupStates(data).then(() => {
            if (isMounted) {
                setSaveState(IDLE)
                dispatch(closeModal())
            }
            dispatch(setNotAssignedMarkovGroupStateSelected(null))

            dispatch(setMarkovGroupStateReloadList(false))
            setTimeout(() => {
                dispatch(setMarkovGroupStateReloadList(true))
            }, 0)
        })
    }

    const columns = Columns()

    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.selectState_s}</PageTitle>
            </PageHeader>
            <PageContent>
                <TableSearchWrapper>
                    <MarkovStateSearch
                        id="notAssignedGroupStates"
                        filters={filters}
                        onFilter={onFilter}
                    />
                </TableSearchWrapper>
                <Table
                    columns={columns}
                    dataList={stateList}
                    dataIds={stateIds}
                    selectedIds={selected}
                    sortColumn={sortColumn}
                    sortOrder={sortOrder}
                    rowSize="sm"
                    showPagination
                    onSort={onSort}
                />
                <PageForm>
                    <Button variant="success" onClick={addGroupStates}>
                        {saveState === PENDING ? <SpinnerIcon /> : lang.select}
                    </Button>
                </PageForm>
            </PageContent>
        </Container>
    )
}
export default NotAssignedGroupStates
